import React from "react";
import Drawer from "./Drawer";

const Header = () => {
  return (
    <div
      id="header"
      style={{
        display: "flex",
        flexDirection: "row",
        justifyContent: "space-between",
        alignItems: "center",
        boxSizing: "border-box"
      }}>
      <div className="header-container">
        {/* <h1
          className="main-header"
          style={{ letterSpacing: "5.5px", fontWeight: 400, margin: 0, marginBottom: 0 }}>
          STARNEX
        </h1> */}
        <img src={require("../../assets/images/black-bg-logo.png")} className="header-logo" />
        {/* <h5 className="sub-header">Redefining Talent Discovery</h5> */}
      </div>
      <Drawer />
    </div>
  );
};

export default Header;
